export default theme => ({
  root: {
    minHeight: '100vh',
    marginBottom: 40
  },

  // HEADER
  headerWrap: {
    background: 'transparent',
    boxShadow: 'none',
    padding: '20px 0'
  },
  toolbar: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }
  },
  naviWrap: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'space-between'
    }
  },
  logoImg: {
    width: 175,
    [theme.breakpoints.down('sm')]: {
      width: 125
    }
  },

  // MAIN GRID / CONTENT
  mainGrid: {
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(3)
    }
  },
  contentContainer: {
    maxWidth: 900,
    margin: '0 auto',
    textAlign: 'justify',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2), // ✅ ensure padding on mobile
    }
  },

  // TERMS BODY
  termsContent: {
    padding: 10,
    minHeight: 'calc(100vh - 305px)',
    fontFamily: 'Roboto',
    fontSize: 14,
    lineHeight: '22px',
    width: '100%',
    color: '#2f2f2f',
    '& p': {
      marginBottom: 10
    }
  },

  // BUTTONS: Agree / Cancel in same line, but responsive
  buttonWrap: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',          // ✅ wrap buttons on small screens
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
    padding: theme.spacing(0, 2),
    paddingBottom: theme.spacing(4), // add breathing room at the bottom
    marginBottom: theme.spacing(3),
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column', // ✅ stack vertically on phones
      alignItems: 'stretch',   // ✅ full width buttons
    }
  },
  roundButton: {
    textTransform: 'none',
    padding: '10px 30px',
    lineHeight: '16px',
    width: 'auto',
    [theme.breakpoints.down('xs')]: {
      width: '100%',           // ✅ full width on mobile
      fontSize: '0.75rem',     // ✅ smaller text fits phone screen
      height: 'auto',
      padding: theme.spacing(1, 2),
      whiteSpace: 'normal',    // ✅ allow text to wrap
      lineHeight: 1.4,
    }
  }
});
